// Renders a 1200x630 shareable result card as a PNG via <canvas>.
// This is the downloadable artifact users post to TikTok/Reddit/X.

import { RealityScore } from "./realityScore";

export interface ResultCardOptions {
  probabilityLabel: string; // e.g. "0.34%"
  fractionLabel: string; // e.g. "1 out of every 294 women"
  compatibleLabel: string; // e.g. "~183,000 women in the US"
  realityScore: RealityScore;
  noun: "women" | "men";
}

export function generateResultCardPngUrl(options: ResultCardOptions): string | null {
  const canvas = document.createElement("canvas");
  canvas.width = 1200;
  canvas.height = 630;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  // Background
  const gradient = ctx.createLinearGradient(0, 0, 1200, 630);
  gradient.addColorStop(0, "#0f172a");
  gradient.addColorStop(1, "#1e3a5f");
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, 1200, 630);

  // Accent bar
  ctx.fillStyle = "#3b82f6";
  ctx.fillRect(0, 0, 1200, 8);

  ctx.textAlign = "center";

  // Header
  ctx.fillStyle = "#94a3b8";
  ctx.font = "600 30px system-ui, -apple-system, sans-serif";
  ctx.fillText(
    options.noun === "men" ? "MALE PARTNER CALCULATOR" : "FEMALE PARTNER CALCULATOR",
    600,
    80
  );

  // Big probability
  ctx.fillStyle = "#60a5fa";
  ctx.font = "800 150px system-ui, -apple-system, sans-serif";
  ctx.fillText(options.probabilityLabel, 600, 250);

  // Fraction
  ctx.fillStyle = "#e2e8f0";
  ctx.font = "500 40px system-ui, -apple-system, sans-serif";
  ctx.fillText(`of US ${options.noun} match these standards`, 600, 315);
  ctx.fillStyle = "#94a3b8";
  ctx.font = "400 32px system-ui, -apple-system, sans-serif";
  ctx.fillText(options.fractionLabel, 600, 365);
  ctx.fillText(options.compatibleLabel, 600, 410);

  // Reality score pill
  const pillWidth = 640;
  const pillX = (1200 - pillWidth) / 2;
  ctx.fillStyle = "#1e293b";
  if (typeof ctx.roundRect === "function") {
    ctx.beginPath();
    ctx.roundRect(pillX, 450, pillWidth, 90, 45);
    ctx.fill();
  } else {
    ctx.fillRect(pillX, 450, pillWidth, 90);
  }
  ctx.fillStyle = "#fbbf24";
  ctx.font = "700 40px system-ui, -apple-system, sans-serif";
  ctx.fillText(
    `Reality Score ${options.realityScore.score}/10 - ${options.realityScore.band}`,
    600,
    508
  );

  // Footer
  ctx.fillStyle = "#64748b";
  ctx.font = "500 28px system-ui, -apple-system, sans-serif";
  ctx.fillText("femalepartnercalculator.com", 600, 595);

  return canvas.toDataURL("image/png");
}

export function downloadResultCard(options: ResultCardOptions) {
  const url = generateResultCardPngUrl(options);
  if (!url) return;
  const link = document.createElement("a");
  link.href = url;
  link.download = "my-dating-reality-check.png";
  link.click();
}
